import { getResourceErrorKind, ResourceErrorKind } from '../helpers/ResourceErrorHelper'

/**
 * Tela de detalhe (/pedidos/:id, /produtos/:id...) que troca o conteudo por
 * <ResourceNotFound> quando o registro da rota nao carrega.
 */
export default {
    data() {
        return {
            loadError: null,
        }
    },
    computed: {
        loadErrorKind():ResourceErrorKind {
            return getResourceErrorKind((this as any).loadError)
        },
        loadErrorMessage():string {
            const error = (this as any).loadError

            return (error && error.message) || ''
        },
    },
}
